import { createStructuresRoute } from '@/router/utils';
import { handleTranslations, } from '@/layouts/_components/Notifications/_util/notification-factory';
export const handleAddedNewStructureNotification = (notification) => {
    const { type, payload: { brand, structure }, } = notification;
    return {
        getTranslations() {
            const translationPlaceholders = {
                ...structure,
            };
            return handleTranslations(type, translationPlaceholders);
        },
        getRoute() {
            return createStructuresRoute(brand.id);
        },
    };
};
